import FanOperationType from "src/consts/FanOperationType";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import NoticeCard from "./NoticeCard";
import { Button } from "antd";
import React from "react";

interface NoOperationsCardProps{
    binDto: PremierPlusBinDTO | null | undefined;
    handleShowFanSettingsModal: () => void;
}

const NoOperationsCard = ({ binDto, handleShowFanSettingsModal }: NoOperationsCardProps) => {
  

    return(
        <NoticeCard
        title="No Operations are active"
        description="There are no active operations. Only fans can be started remotely. Starting dryer & moving grain must be done on-site on the HMI touch screen"
        buttons={
            <Button onClick={handleShowFanSettingsModal} type="primary">
                Run Fans
            </Button>
        }
        />
    )
}

export default NoOperationsCard;